import omit from 'lodash/omit';

// Constants
import FeedbacksConstants from 'Shared/constants/Feedbacks.constants';
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';

import { mapObjectsForRedux } from './utils';

const feedbacks = (state = [], action) => {
  switch (action.type) {
    case FeedbacksConstants.Actions.FETCH_FEEDBACKS_SUCCESS:
    case FeedbacksConstants.Actions.FETCH_SINGLE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.CREATE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.UPDATE_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.VIEW_FEEDBACK_SUCCESS:
    case FeedbacksConstants.Actions.FEEDBACKS_SYNC_SUCCESS:
    case UserSuggestionsConstants.Actions.FETCH_USER_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        ...mapObjectsForRedux(action.payload.feedback),
      };
    case FeedbacksConstants.Actions.UPDATE_FEEDBACK_REQUEST:
    case FeedbacksConstants.Actions.UPDATE_FEEDBACK_FAILURE:
    case FeedbacksConstants.Actions.DESTROY_FEEDBACK_FAILURE:
      return { ...state, [action.payload.uuid]: action.payload };
    case FeedbacksConstants.Actions.DESTROY_FEEDBACK_REQUEST:
      return omit(state, action.payload);
    default:
      return state;
  }
};

export default feedbacks;
